import { render, staticRenderFns } from "./scrollItem.vue?vue&type=template&id=7c444fb4"
import script from "./scrollItem.vue?vue&type=script&lang=js"
export * from "./scrollItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports